<template>
    <div class="indexInfo_page">
        <div class="header">
            <el-date-picker
                v-model="week"
                type="week"
                format="yyyy 第 WW 周"
                placeholder="选择周"
                @change="selectWeek"
                :picker-options="{
                    firstDayOfWeek: 1
                }"
                style="margin-right:20px"
                :default-value="week"
                >
            </el-date-picker>
            <el-button type="primary" @click="dialogFormVisible = true">快速预约</el-button>
            <div class="select_room">
                <el-select class="select_dom" v-model="selectRoomId" placeholder="请选择会议室">
                    <el-option
                    v-for="item in options"
                    :key="item.room_id"
                    :label="item.room_name"
                    :value="item.room_id">
                    </el-option>
                </el-select>
                <el-button type="primary" @click="getRoomListById">确定</el-button>
            </div>
            
        </div>
        <table class="index_table">
            <thead>
                <tr>
                    <th>{{ weekDate }}</th>
                    <th>周一</th>
                    <th>周二</th>
                    <th>周三</th>
                    <th>周四</th>
                    <th>周五</th>
                    <th>周六</th>
                    <th>周日</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="morningList.length != 0">
                    <td>上午</td>
                    <td v-for="(list, index) in morningList" :key="index">
                        <p v-for="item in list" :key="item.id">
                            <template v-if="item.status==1">{{ item.room.name }}:{{ item.organizer }}(未审批)</template>
                            <template v-else-if="item.status==2">{{ item.room.name }}:{{ item.organizer }}(已审批)</template>
                            <template v-else-if="item.status==4">{{ item.room.name }}:{{ item.organizer }}(已结束)</template>
                        </p>
                    </td>
                </tr>
                <tr v-else>
                    <td>上午</td>
                    <td v-for="(n, index) in 7" :key="index"></td>
                </tr>
                <tr v-if="afternoonList.length != 0">
                    <td>下午</td>
                    <td v-for="(list, index) in afternoonList" :key="index">
                        <p v-for="item in list" :key="item.id">
                            <template v-if="item.status==1">{{ item.room.name }}:{{ item.organizer }}(未审批)</template>
                            <template v-else-if="item.status==2">{{ item.room.name }}:{{ item.organizer }}(已审批)</template>
                            <template v-else-if="item.status==4">{{ item.room.name }}:{{ item.organizer }}(已结束)</template>
                        </p>
                    </td>
                </tr>
                <tr v-else>
                    <td>下午</td>
                    <td v-for="(n, index) in 7" :key="index"></td>
                </tr>
                <tr v-if="nightList.length != 0">
                    <td>晚上</td>
                    <td v-for="(list, index) in nightList" :key="index">
                        <p v-for="item in list" :key="item.id">
                            <template v-if="item.status==1">{{ item.room.name }}:{{ item.organizer }}(未审批)</template>
                            <template v-else-if="item.status==2">{{ item.room.name }}:{{ item.organizer }}(已审批)</template>
                            <template v-else-if="item.status==4">{{ item.room.name }}:{{ item.organizer }}(已结束)</template>
                        </p>
                    </td>
                </tr>
                <tr v-else>
                    <td>晚上</td>
                    <td v-for="(n, index) in 7" :key="index"></td>
                </tr>
            </tbody>
        </table>
        <el-dialog title="预约会议室" :visible.sync="dialogFormVisible">
            <el-form :model="appointment" label-width="80px" :rules="formRules">
                <el-form-item label="预约时间">
                    <el-date-picker
                    v-model="dateRange"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :default-time="['08:00:00', '12:00:00']"
                    >
                    </el-date-picker>
                    <el-button type="primary" @click="searchRoomByTime" style="margin-left: 20px;">搜索</el-button>
                </el-form-item>
                <el-form-item label="会议室" prop="room_id">
                    <el-select v-if="isSeacher" v-model="appointment.room_id" placeholder="请选择会议室">
                        <el-option v-for="item in roomList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <div v-else style="color:red;">选择日期后点击搜索按钮</div>
                </el-form-item>
                <el-form-item label="主题" prop="theme">
                    <el-input v-model="appointment.theme"></el-input>
                </el-form-item>
                <el-form-item label="主办单位" prop="organizer">
                    <el-input v-model="appointment.organizer" placeholder="院内预约请注明所属课题组"></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="contacts">
                    <el-input v-model="appointment.contacts"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="contacts_number">
                    <el-input v-model="appointment.contacts_number"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitDialogForm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="预约会议室" :visible.sync="dialogTableVisible" @close="closeHandle" :fullscreen=true center>
            <el-table
            :data="subscribeList"
            size="mini"
            style="max-width: 100%;height: 205px;overflow: auto;">
                <el-table-column
                    prop="room.name"
                    label="会议室">
                </el-table-column>
                <el-table-column
                    prop="start_time"
                    label="开始时间">
                </el-table-column>
                <el-table-column
                    prop="end_time"
                    label="结束时间">
                </el-table-column>
                <el-table-column
                    prop="theme"
                    label="主题">
                </el-table-column>
                <el-table-column
                    prop="organizer"
                    label="主办单位">
                </el-table-column>
                <el-table-column
                    prop="contacts"
                    label="联系人">
                </el-table-column>
                <el-table-column
                    prop="contacts_number"
                    label="联系电话">
                </el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status=='1'? true:false" type="primary" disable-transitions>审批中</el-tag>
                        <el-tag v-if="scope.row.status=='2'? true:false" type="success" disable-transitions>通过审批</el-tag>
                        <el-tag v-if="scope.row.status=='3'? true:false" type="danger" disable-transitions>拒绝审批</el-tag>
                        <el-tag v-if="scope.row.status=='4'? true:false" type="info" disable-transitions>会议结束</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            
            <el-form :model="appointment2" label-width="80px" class="appointmentForm" :rules="formRules2">
                <el-form-item label="预约时间">
                    <el-date-picker
                        v-model="dateRange2"
                        type="datetimerange"
                        align="right"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        :default-time="['08:00:00', '12:00:00']">
                    </el-date-picker>
                </el-form-item>
                    <el-form-item label="会议室" prop="room_id">
                        <el-input v-model="appointment2.room_id" :placeholder="selectRoomName" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="主题" prop="theme">
                        <el-input v-model="appointment2.theme"></el-input>
                    </el-form-item>
                    <el-form-item label="主办单位" prop="organizer">
                        <el-input v-model="appointment2.organizer" placeholder="院内预约请注明所属课题组"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人" prop="contacts">
                        <el-input v-model="appointment2.contacts"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="contacts_number">
                        <el-input v-model="appointment2.contacts_number"></el-input>
                    </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding-bottom:50px">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitDialogTable">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {date2string, weekDate} from '../assets/js/index.js'
export default {
    data(){
        return {
            appointment: {
                room_id: null,
                theme: null,
                start_time: null,
                end_time:null,
                organizer: null,
                contacts:null,
                contacts_number: null,
            },
            dialogFormVisible: false,
            dateRange: null,
            dateRange2: null,
            roomList: [],
            options: [],
            selectRoomId: null,
            selectRoomName: null,
            subscribeList:[],
            dialogTableVisible: false,
            morningList: [],
            afternoonList: [],
            nightList: [],
            isSeacher: false,
            appointment2: {
                room_id: null,
                theme: null,
                start_time: null,
                end_time:null,
                organizer: null,
                contacts:null,
                contacts_number: null,
            },
            weekDate: weekDate(),
            week: new Date(),
            formRules: {
                room_id: [
                    {required: true, message: '请选择会议室'}
                ],
                theme: [
                    {required:true, message: '请输入主题'}
                ],
                organizer: [
                    {required:true, message: '请输入主办单位，院内预约请注明所属课题组'}
                ],
                contacts: [
                    {required:true, message: '请输入联系人'}
                ],
                contacts_number: [
                    {required:true, message: '请输入联系电话'}
                ]
            },
            formRules2: {
                theme: [
                    {required:true, message: '请输入主题', trigger: 'blur'}
                ],
                organizer: [
                    {required:true, message: '请输入主办单位，院内预约请注明所属课题组', trigger: 'blur'}
                ],
                contacts: [
                    {required:true, message: '请输入联系人', trigger: 'blur'}
                ],
                contacts_number: [
                    {required:true, message: '请输入联系电话', trigger: 'blur'}
                ]
            }
        }
    },
    mounted(){
        let time = new Date()
        this.getAllRoom()
        this.getWeekDate(date2string(time))
    },
    methods: {
        searchRoomByTime(){
            let startTime = date2string(this.dateRange[0])
            let endTime = date2string(this.dateRange[1])
            this.$axios.post('/subscribe/search_room_by_time/',{
                startTime: startTime,
                endTime: endTime
            })
            .then(res => {
                if (res.status === 1) {
                    this.roomList = res.data.list
                }
            })
            this.isSeacher = true
        },
        submitDialogForm(){
            this.appointment.start_time = date2string(this.dateRange[0])
            this.appointment.end_time = date2string(this.dateRange[1])
            if (!this.dateRange) {
                this.$message.info('请选择预约时间')
                return false
            } else if (!this.appointment.room_id) {
                this.$message.error('会议室不能为空')
                return false
            } else if (!this.appointment.theme) {
                this.$message.error('主题不能为空')
                return false
            } else if (!this.appointment.organizer) {
                this.$message.error('主办单位不能为空')
                return false
            } else if (!this.appointment.contacts) {
                this.$message.error('联系人不能为空')
                return false
            } else if (!this.appointment.contacts_number) {
                this.$message.error('联系电话不能为空')
                return false
            } 
            this.$confirm('确认提交吗？')
            .then(() => {
                this.$axios.post('/subscribe/', this.appointment)
                .then(res => {
                    console.log(res)
                    if (res.status === 1) {
                        this.$message.success('提交成功')
                        this.dialogFormVisible = false
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
            })
        },
        getAllRoom(){
            this.$axios.get('/subscribe/room_list/')
            .then(res => {
                if (res.status === 1) {
                    this.options = res.data
                }
            })
        },
        getRoomListById(){
            if (!this.selectRoomId) {
                this.$message.info('请先选择会议室')
                return false
            }
            this.dialogTableVisible = true
            let url = '/subscribe/search_room_by_id/?room_id=' + this.selectRoomId
            for (let item of this.options) {
                if (item.room_id == this.selectRoomId) {
                    this.selectRoomName = item.room_name
                    break
                }
            }
            this.$axios.get(url)
            .then(res => {
                console.log(res)
                if (res.status === 1) {
                    this.subscribeList = res.data
                }
            })
        },
        getWeekDate(date){
            this.$axios.post('/subscribe/week_data/',{
                dataTime: date
            })
            .then(res => {
                if (res.status === 1) {
                    this.morningList = res.data.morning
                    this.afternoonList = res.data.afternoon
                    this.nightList = res.data.night
                }
            })
        },
        closeHandle(){
            this.subscribeList = []
        },
        submitDialogTable(){
            console.log(this.appointment2)
            if (!this.dateRange2) {
                this.$message.info('请选择预约时间')
                return false
            } else if (!this.appointment2.theme) {
                this.$message.error('主题不能为空')
                return false
            } else if (!this.appointment2.organizer) {
                this.$message.error('主办单位不能为空')
                return false
            } else if (!this.appointment2.contacts) {
                this.$message.error('联系人不能为空')
                return false
            } else if (!this.appointment2.contacts_number) {
                this.$message.error('联系电话不能为空')
                return false
            }
            this.appointment2.start_time = date2string(this.dateRange2[0])
            this.appointment2.end_time = date2string(this.dateRange2[1])
            this.appointment2.room_id = this.selectRoomId
            this.$confirm('确认提交吗？')
            .then(() => {
                this.$axios.post('/subscribe/', this.appointment2)
                .then(res => {
                    if (res.status === 1) {
                        this.$message.success('提交成功')
                        this.dialogTableVisible = false
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            })
            .catch(res => {
                this.$message.info('已取消')
            })
        },
        selectWeek(){
            this.getWeekDate(date2string(this.week))
            this.weekDate = weekDate(this.week)
        }
    }
}
</script>
<style lang="less" scoped>
.indexInfo_page{
    padding: 20px;
    .header{
        .select_room{
            float: right;
            .select_dom{
                margin-right: 20px;
            }
        }
    }
    .index_table{
        margin-top: 25px;
        width: 100%;
        table-layout: fixed;
        thead {
            background-color: #67a1ff;
            th {
                color: #fff;
                line-height: 17px;
                font-weight: normal;
            }
        }
        tbody {
            background-color: #eaf2ff;
            td {
                color: #677998;
                line-height: 12px;
            }
        }
        th,td {
            width: 60px;
            padding: 12px 2px;
            font-size: 12px;
            text-align: center;
        }
        tr td:first-child {
            color: #333;
            .period {
                font-size: 8px;
            }
        }
        
    }   
    .appointmentForm{
        width: 50%;
        margin: 50px auto;
    }
}
</style>